import { FC, HTMLAttributes, MouseEventHandler, ReactNode } from 'react'
import Typography from '../typography/Typography'
import Icon from '../icon/Icon'
import { AlertType, IconNames } from '../Types'
import styles from './Alert.module.scss'
interface AlertProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: string | React.ReactNode
  icon?: IconNames
  onClose?: MouseEventHandler<HTMLDivElement>
  type: AlertType
  data_cy?: string
  className?: string
}
const Alert: FC<AlertProps> = ({
  title,
  icon,
  onClose,
  type,
  data_cy,
  className = '',
  ...props
}) => {
  return (
    <div
      {...props}
      className={
        styles[`alert-container`] +
        ' ' +
        styles[`color-${type}`] +
        ' ' +
        className
      }
      data-cy={data_cy}
    >
      <div className={styles['title-section']}>
        {icon && (
          <div className={styles['icon-container']}>
            <Icon name={icon} size={16} type={type} />
          </div>
        )}
        <Typography className={styles['title-wrapper']} variant="bodyM">
          {title}
        </Typography>
      </div>
      {onClose && (
        <div className={styles['close-icon']} onClick={onClose}>
          <Icon name="close" type="mediumEmphasis" size={16} />
        </div>
      )}
    </div>
  )
}
export default Alert
